export default __webpack_public_path__ + "static/media/share-maroon.78e6e659.svg";